import { render, staticRenderFns } from "./VersionHintTime.vue?vue&type=template&id=2232cf73&scoped=true"
import script from "./VersionHintTime.vue?vue&type=script&lang=ts"
export * from "./VersionHintTime.vue?vue&type=script&lang=ts"
import style0 from "./VersionHintTime.vue?vue&type=style&index=0&id=2232cf73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232cf73",
  null
  
)

export default component.exports